import { CopyOutlined, EyeInvisibleOutlined, EyeOutlined, LoadingOutlined, RedoOutlined } from '@ant-design/icons'
import {forwardRef, useImperativeHandle, useState} from 'react'
import { iiHOC } from '@/utils/auth'
import UrlParse from 'url-parse'
import {Button, Popover, Tooltip} from "antd";

// 酷家乐账号密码
export const CheckThePwd = (props: any) => {
  const { record, dataIndex, auth } = props
  const [_fullPhone, _setFullPhone] = useState<boolean>(false)
  return iiHOC(
    <div style={{ display: 'flex' }}>
      <div style={{maxWidth: 150, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{!_fullPhone ? '****' : <Tooltip title={record[dataIndex]}>{record[dataIndex]}</Tooltip>}</div>
      <div
        style={{ marginLeft: '6px', cursor: 'pointer' }}
        onClick={() => {
          if (!_fullPhone) {
            _setFullPhone(true)
          } else {
            _setFullPhone(false)
          }
        }}
      >
        {/* isBtnObj &&  */}
        {/* 权限校验暂时屏蔽 */}
        {_fullPhone ? (
          <EyeOutlined datareskey={auth} />
        ) : (
          <EyeInvisibleOutlined datareskey={auth} />
        )}
      </div>
    </div>
  )
}

// 小程序码
export const LinkCustomRender = (props: any) => {
  const { link } = props
  if (!link) return null
  const url = new UrlParse(link)
  const protocol = url?.protocol?.toLowerCase()
  const PopoverDom = () => {
    if (protocol === 'http:' || protocol === 'https:') {
      return (
          <Tooltip placement="topLeft" title={link}>
            <Button
                type="link"
                size="small"
                onClick={() => {
                  window.open(link)
                }}
            >
              查看页面
            </Button>
          </Tooltip>
      )
    } else {
      const appKeyLength = url.host.length
      const appKey = link.substring(12, 12 + appKeyLength)

      let pathname = url.pathname
      if (pathname.startsWith('/')) {
        pathname = pathname.substring(1)
      }
      // const releaseEnv = location.host.includes('svi');
      // const host = releaseEnv ? 'https://svi.shj.cn' : 'https://o3.shjmall.cn';
      const releaseEnv = location.hostname.includes('saas.shj.cn')
      const host = releaseEnv ? 'https://saas.shj.cn' : 'https://shj-saas.shjmall.cn'
      const envVersion = releaseEnv ? 'release' : 'trial'
      const query = url.query ? encodeURIComponent(url.query.substring(1)) : ''
      const imageUrl = `${host}/api/api-wx/wx/miniapp/commons/${appKey}/createUrlQrCode?envVersion=${envVersion}&path=${pathname}&query=${query}`
      return (
          <Popover
              title="小程序码"
              trigger="hover"
              content={() => (
                  <Image
                      src={imageUrl}
                      preview={false}
                      width={280}
                      placeholder={
                        <div style={{ textAlign: 'center' }}>
                          <LoadingOutlined />
                        </div>
                      }
                  />
              )}
          >
            <Button type={'link'} size={'small'}>
              小程序
            </Button>
          </Popover>
      )
    }
  }
  return <PopoverDom />
}

export const RefreshIcon: React.FC<any> = forwardRef((props, ref) => {
  const { fn } = props
  const [loading, setLoading] = useState<boolean>(false)
  const onFinish = () => {
    setLoading(false)
  }
  useImperativeHandle(
      ref,
      () => ({
        onFinish,
      }),
      [onFinish]
  )
  return loading ? (
      <LoadingOutlined />
  ) : (
      <RedoOutlined
          onClick={() => {
            setLoading(true)
            fn && fn()
          }}
          style={{ color: 'rgb(24, 144, 255)', fontSize: '14px' }}
      />
  )
})

